module.exports = __webpack_public_path__ + "static/media/inote.cc2caf78.svg";